export default __webpack_public_path__ + "static/media/no-result.426db8cf.svg";